// utils/clearISTCameraSession.js
export function clearISTCameraSession() {
  Object.keys(localStorage)
    .filter((k) => k.startsWith('camera:ist:'))
    .forEach((k) => localStorage.removeItem(k))
}
